enum EDaysOnLot {
  ZeroToFifteen = "0-15",
  SixteenToThirty = "16-30",
  ThirtyOneToFortyFive = "31-45",
  FortySixToSixty = "46-60",
  SixtyAbove = "60+",
}

export default EDaysOnLot;
